import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const PROGRAMS = [
  {
    code: "P01",
    title: "New Driver Preparation Program",
    body: "Designed for individuals preparing to become school bus drivers.",
    items: ["School bus safety basics","CDL school bus readiness support","Passenger safety awareness","Pre-trip inspection","Mirror use","Danger zones","Student loading and unloading","Railroad crossing procedures","Emergency procedures","Basic vehicle control","Professional expectations"],
  },
  {
    code: "P02",
    title: "Pre-Trip Mastery Program",
    body: "Focused on helping trainees learn the full school bus pre-trip inspection.",
    items: ["Exterior inspection","Interior inspection","Engine compartment","Brake checks","Emergency equipment","What to inspect","What to say","What defects to identify","Common mistakes","Practice structure","Trainer sign-off checklists"],
  },
  {
    code: "P03",
    title: "Behind-the-Wheel Readiness Program",
    body: "Prepares drivers for safe bus operation.",
    items: ["Lane positioning","Mirror use","Right turns","Left turns","Tail swing","Off-tracking","Curves","Intersections","Railroad crossings","Backing awareness","Space management","Speed management","Hazard awareness","Professional road behavior"],
  },
  {
    code: "P04",
    title: "Refresher Driver Program",
    body: "For experienced drivers who need to review procedures or rebuild confidence.",
    items: ["Safety review","Pre-trip review","Defensive driving","Mirror use","Turns and backing","Loading and unloading review","Emergency procedures","Professional expectations"],
  },
  {
    code: "P05",
    title: "Corrective Action Training Program",
    body: "For drivers involved in preventable incidents or unsafe behaviors.",
    items: ["Incident review","Root cause discussion","Correct procedure training","Skills practice","Written reflection","Trainer observation","Follow-up recommendations"],
  },
];

const FOCUS = ["Knowledge","Safety habits","Inspection skills","Vehicle control","Observation","Communication","Student safety","Decision-making","Professional responsibility"];

export default function TrainingPrograms() {
  return (
    <>
      <PageHero
        testid="programs-hero"
        eyebrow="Training Programs"
        title="Real-world operations. Practical safety. Driver readiness."
        description="CLB Solution training is designed around real-world school bus operations, practical safety procedures, and driver readiness."
        image={IMAGES.safetyTopics}
      />

      <Section testid="programs-focus">
        <SectionTitle eyebrow="Training Focus" title="Nine pillars of safe school transportation." />
        <BulletGrid items={FOCUS} testid="programs-focus-grid" />
      </Section>

      {PROGRAMS.map((p, i) => (
        <Section key={p.code} testid={`program-${p.code}`} className={i % 2 === 0 ? "bg-[#0c0c0e] border-y border-white/10" : ""}>
          <div className="grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <div className="font-mono text-xs text-[#FFCC00] mb-2">{p.code}</div>
              <h2 className="font-display text-2xl md:text-4xl font-bold uppercase tracking-tight leading-[1.05]">{p.title}</h2>
              <p className="mt-4 text-white/65">{p.body}</p>
            </div>
            <div className="lg:col-span-8">
              <BulletGrid items={p.items} testid={`program-${p.code}-items`} />
            </div>
          </div>
        </Section>
      ))}

      <CTABand />
    </>
  );
}
